<div class="popup-container">
  <div class="scroll-container">
    <div class="flex flex-row justify-between items-center pl-12 pr-12 fw-700 fs-12 tooltip-header">
      <label>{{'CUSTOM_TOOLTIP.COMPONENT_NAME' | transloco | uppercase}}</label>
      <label>{{'CUSTOM_TOOLTIP.STATUS' | transloco | uppercase}}</label>
    </div>
    <div class="flex flex-col">
      <div *ngFor="let result of data" class="flex flex-row justify-between items-center pl-12 pr-12 mat-body fs-12 tooltip-row">
        <div>{{result?.name}} <span *ngIf="result?.componentType" class="comp-type ml-8 pl-8 pr-8 pb-2">{{result.componentType}}</span></div>
        <div>
          <ng-container *ngIf="result?.status === 'inprogress'; else otherStatus">
            <mat-spinner diameter="20" color="primary" mode="indeterminate"></mat-spinner>
          </ng-container>
          <ng-template #otherStatus>
            <mat-icon [svgIcon]="result?.status === 'success' ? 'done' : 'close'" [ngClass]="result?.status === 'success' ? 'sucess-circle icon-sm p-2' : 'failed-circle icon-sm p-2'"></mat-icon>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>